import { Dispatch } from "redux";
import { GET_ALL_ROLES, RESET_DATA } from "./action-types";
import apiLibrary from "services/api";
import { generateQueryStringForUsers } from "utils/convertFiltersToQueryString";
import { Toasts } from "view/components/Toasts";

export const fetchRolesAction =
  () => async (dispatch: Dispatch, getState: any) => {
    // dispatch(loadingState(true))
    try {
      const currentState = getState();
      const queryString = generateQueryStringForUsers(
        currentState.Filters.rolesFilter
      );

      const { data } = await apiLibrary.RolesPermissions.getAllRoles(queryString);
      dispatch({
        type: GET_ALL_ROLES,
        payload: data ,
      });
    } catch (error: any) {
      const errorMsg = error?.response?.data?.message ?? error?.message;
      Toasts.error(errorMsg);

      dispatch({
        type: RESET_DATA,
      });
      console.log("An error occurred while fetching the notifications:", error);
      // dispatch(fetchError(error))
    } finally {
      // dispatch(loadingState(false))
    }
  };
